import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tooltip,
  TextField,
  Button,
  Grid,
  IconButton,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import PaypalIcon from '../../assets/PaypalIcon.png';
import VisaIcon from '../../assets/VisaIcon.png';
import MastercardIcon from '../../assets/MastercardIcon.png';
import DinersIcon from '../../assets/DinersIcon.png';
import AmexIcon from '../../assets/AmexIcon.png';
import { API_ENDPOINTS } from '../../config/constants';
import axios from 'axios';

const paymentOptions = [
  { id: 'paypal', label: 'PayPal', icon: PaypalIcon },
  { id: 'visa', label: 'Visa', icon: VisaIcon },
  { id: 'mastercard', label: 'MasterCard', icon: MastercardIcon },
  { id: 'diners', label: 'Diners', icon: DinersIcon },
  { id: 'amex', label: 'Amex', icon: AmexIcon },
];

const PaymentForm = ({ timeData,onVerify,orderId,portData,onNext, onBack }) => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [formData, setFormData] = useState({
    cardNumber: '',
    expiry: '',
    securityCode: '',
  });

  const handleInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const generatePaymentId=(length = 14)=>{
  const prefix = "pay_";
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomPart = "";
  for (let i = 0; i < length; i++) {
    randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return prefix + randomPart;
}

  const handleSubmit = async () => {
    const token = localStorage.getItem('token');
    const paymentDetails = {
      orderId: orderId,
      paymentId: generatePaymentId(),
      signature: "b45fcbf89e3641e3c705d012f21a7b87860413cf",
      paymentMethod: "card"
    };
    try {
      const response = await axios.post(API_ENDPOINTS.PAYMENT_CONFIRMATION, paymentDetails, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log('Payment Confirmation Response:', response.data);
      onVerify('success');
      onNext(response.data);
    }catch (error) {
      console.error('Error confirming payment:', error);
    }
    };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      width="100%"
      maxWidth="400px"
    >
      <Typography
        fontFamily="Mulish"
        fontWeight={500}
        fontSize="18px"
        textAlign="center"
        color="#000"
      >
        Payment
      </Typography>
      <Typography
        fontFamily="Mulish"
        fontWeight={400}
        fontSize="18px"
        textAlign="center"
        color="#000"
      >
        Selected Port Number : {portData?.port_number}
      </Typography>

      {/* Payment Options */}
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        gap={{ xs: 1, sm: 2 }}
        width="100%"
        paddingX={1}
      >
        {paymentOptions.map((method) => {
          const isSelected = selectedMethod === method.id;
          return (
            <Tooltip title={method.label} key={method.id} arrow>
              <Box
                onClick={() => setSelectedMethod(method.id)}
                sx={{
                  width: isSelected ? 'clamp(44px, 15vw, 60px)' : 'clamp(36px, 13vw, 48px)',
                  height: isSelected ? 'clamp(44px, 15vw, 60px)' : 'clamp(36px, 13vw, 48px)',
                  border: '1px solid #CECECE',
                  boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '8px',
                  padding: '5px',
                  position: 'relative',
                  backgroundColor: '#fff',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease-in-out',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={method.icon}
                  alt={method.label}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
                {isSelected && (
                  <CheckCircleIcon
                    style={{
                      position: 'absolute',
                      bottom: -8,
                      right: -8,
                      color: '#261863',
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      fontSize: 20,
                    }}
                  />
                )}
              </Box>
            </Tooltip>
          );
        })}
      </Box>

      {/* Amount Card */}
      <Box
        width="100%"
        maxWidth="350px"
        height="85px"
        borderRadius="16px"
        padding="20px 10px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          background: 'linear-gradient(180deg, #1B1A63 0%, #411363 100%)',
          color: '#fff',
        }}
        gap={1}
      >
        <Typography fontFamily="Mulish" fontWeight={500} fontSize="14px">
          Total Amount
        </Typography>
        <Typography fontFamily="Mulish" fontWeight={500} fontSize="20px">
          {timeData?.price}
        </Typography>
      </Box>

      {/* Form */}
      <Box
        width="100%"
        maxWidth="350px"
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <TextField
          label="Card Number"
          name="cardNumber"
          value={formData.cardNumber}
          onChange={handleInput}
          fullWidth
          size="small"
          InputProps={{
            sx: {
              borderRadius: '16px',
            },
          }}
        />

        <TextField
          label="Expiry Date"
          placeholder="MM/YY"
          name="expiry"
          value={formData.expiry}
          onChange={handleInput}
          fullWidth
          size="small"
          InputProps={{
            sx: {
              borderRadius: '16px',
            },
          }}
        />

        <TextField
          label="Security Code"
          placeholder="CVV"
          name="securityCode"
          type="password"
          value={formData.securityCode}
          onChange={handleInput}
          fullWidth
          size="small"
          InputProps={{
            sx: {
              borderRadius: '16px',
            },
          }}
        />

      </Box>

      {/* Buttons */}
      <Box display="flex" flexDirection="column" gap={1} mt={2} width="100%" maxWidth="350px">
        <Button
          onClick={handleSubmit}
          variant="contained"
          fullWidth
          sx={{
            width: '100%',
            height: '56px',
            borderRadius: '16px',
            backgroundColor: '#261863',
            color: '#fff',
            fontWeight: 'bold',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#1B1A63',
            },
          }}
        >
          Next
        </Button>
        {/* <Button
          onClick={onBack}
          variant="outlined"
          fullWidth
          sx={{
            width: '350px',
            height: '56px',
            borderRadius: '16px',
            color: '#261863',
            borderColor: '#261863',
            fontWeight: 'bold',
            textTransform: 'none',
          }}
        >
          Back
        </Button> */}
      </Box>
    </Box>
  );
};

export default PaymentForm;
